var SUPPORTED_FIELD_TYPES;
(function (SUPPORTED_FIELD_TYPES) {
    SUPPORTED_FIELD_TYPES["Text"] = "Text";
    SUPPORTED_FIELD_TYPES["DateRange"] = "DateRange";
    SUPPORTED_FIELD_TYPES["Date"] = "Date";
    SUPPORTED_FIELD_TYPES["Select"] = "Select";
    SUPPORTED_FIELD_TYPES["MultiSelect"] = "MultiSelect";
    SUPPORTED_FIELD_TYPES["Boolean"] = "Boolean";
})(SUPPORTED_FIELD_TYPES || (SUPPORTED_FIELD_TYPES = {}));
const labeledSettingTypes = [
    SUPPORTED_FIELD_TYPES.Text,
    SUPPORTED_FIELD_TYPES.Date,
    SUPPORTED_FIELD_TYPES.DateRange,
    SUPPORTED_FIELD_TYPES.Select,
    SUPPORTED_FIELD_TYPES.MultiSelect,
];

export { SUPPORTED_FIELD_TYPES, labeledSettingTypes };
//# sourceMappingURL=types.js.map
